/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';

/**
 * 
 * @export
 * @interface OWClaimLog
 */
export interface OWClaimLog {
    /**
     * 
     * @type {number}
     * @memberof OWClaimLog
     */
    target: number;
    /**
     * 
     * @type {number}
     * @memberof OWClaimLog
     */
    date: number;
    /**
     * 
     * @type {number}
     * @memberof OWClaimLog
     */
    amountReceived: number;
    /**
     * 
     * @type {RewardType}
     * @memberof OWClaimLog
     */
    rewardType?: RewardType;
}



/**
 * Check if a given object implements the OWClaimLog interface.
 */
export function instanceOfOWClaimLog(value: object): value is OWClaimLog {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('amountReceived' in value) || value['amountReceived'] === undefined) return false;
    return true;
}

export function OWClaimLogFromJSON(json: any): OWClaimLog {
    return OWClaimLogFromJSONTyped(json, false);
}

export function OWClaimLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWClaimLog {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'date': json['date'],
        'amountReceived': json['amountReceived'],
        'rewardType': json['rewardType'] == null ? undefined : RewardTypeFromJSON(json['rewardType']),
    };
}

export function OWClaimLogToJSON(json: any): OWClaimLog {
    return OWClaimLogToJSONTyped(json, false);
}

export function OWClaimLogToJSONTyped(value?: OWClaimLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'date': value['date'],
        'amountReceived': value['amountReceived'],
        'rewardType': RewardTypeToJSON(value['rewardType']),
    };
}

